$(function() {

	$('form#subject-survey.single-question').each(function() {
		var $form = $(this);
		$('input:radio, label').on('mouseup', function() {
			window.toggleLoader(true);
			setTimeout(function() {
				$form.submit();
			}, 100);
		})
		$('input:radio').on('keyup', function(event) {
			if (event.code == 13) {
				window.toggleLoader(true);
				setTimeout(function() {
					$form.submit();
				}, 100);
			}
		})
	});

});